const IS_DEBUG = window.localStorage.getItem('_debug_') === 'true'

export default function ({ url, name, response }) {
  if (!IS_DEBUG) return

  const defaultCss = [
    `background: #35495e; padding: 1px; border-radius: 4px 0 0 4px;  color: #fff`,
    'background: #41b883; padding: 1px; border-radius: 0 4px 4px 0;  color: #fff',
    'background: #FFFFFF; padding: 1px;'
  ]

  const { data, status, statusText } = response

  console.group('调试信息：网络请求')

  if (name) {
    console.log(`%c ${url} %c ${name} >> %c`, ...defaultCss, data ? data.message : response)
  }

  console.log(`%c ${url} %c response >> %c`, ...defaultCss, response)
  console.log(`%c ${url} %c status >> %c`, ...defaultCss, status)
  console.log(`%c ${url} %c data >> %c`, ...defaultCss, data || statusText)

  console.groupEnd()
}
